module.exports = __webpack_public_path__ + "img/fishes.2c49f1b4.png";